import { takeLatest, select, put, all, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { apiSaga } from '../../../../sagas';
import { push } from 'react-router-redux';
import { contracting as contractingApis, historyFeed as hfApi } from '../../../../api';
import { refreshContractDoc } from '../../__storeFiles__/sagas';

export function* refreshPolicyNotes({ args }) {
  const { crId, contractId, inActivityFeed, isRateContract } = args[0];
  if (window.location.href.indexOf('/assets-landing') > -1) {
    yield apiSaga(
      '[asset-landing]GET_REQUEST',
      contractingApis.getContractInfo,
      [{
        collection: 'contract',
        type: 'policyNotes',
        docId: crId || contractId,
        forAL: true,
      }],
    );
  } else {
    yield all([
      inActivityFeed ? Promise.resolve() : apiSaga(
        '{rates-draft} REFRESH_POLICIES_NOTES',
        contractingApis.getContractInfo,
        [{
          collection: 'contract',
          docId: crId || contractId,
          type: 'policyNotes',
        }],
      ),
      apiSaga(
        '{rates-draft} REFRESH_LEFT_NAV',
        contractingApis.getContractInfo,
        [{
          collection: 'contract',
          docId: isRateContract ? contractId : (crId || contractId),
          type: 'leftNav',
        }],
      ),
    ]);
  }
}

function* refreshActivities({ args }) {
  if (args[0].contractId || args[0].crId) {
    yield apiSaga('LOADING_HISTORY_FEEDS', hfApi.getHistory, [args[0].contractId || args[0].crId]);
  }
}

function* createTemplatesInDummyAcct({ type, payload }) {
  yield apiSaga(type, contractingApis.createTemplatesInDummyAcct, [payload]);
}

function* afterCreateTemplatesInDummyAcctSuccess({ args }) {
  const { rateConversionStatus = '', crId } = yield select(state => state.dummyAcct.inCR);
  if (rateConversionStatus.toLowerCase() === 'awaiting supplier rates' || rateConversionStatus.toLowerCase() === 'in queue') {
    // eslint-disable-next-line no-use-before-define
    yield updateWorkspaceContract({
      type: '[contract-request] UPDATE_RATE_LOADING_STATUS',
      payload: { contractId: crId, updater: { rateConversionStatus: 'In Progress' } },
    });
  } else {
    yield refreshPolicyNotes({ args });
  }
}

function* acceptDummyTemplate({ type, payload }) {
  const confirm = window.confirm(`Please be informed that by accepting this rate sheet, you will no longer be able to request a signature from your supplier.`);
  if (confirm) {
    yield apiSaga(type, contractingApis.acceptDummyTemplate, [{
      rateDocId: payload.rateDocId,
      from: 'buyer-acct-cr',
    }]);
  }
}
function* afterAcceptDummyTemplate({ payload }) {
  if (payload.contractId) {
    yield put(push(`/contracting/contract/${payload.contractId}/details`));
  } else if (payload.templateId) {
    yield put(push(`/contracting/template/${payload.templateId}/details`));
  } else yield refreshContractDoc();
}

function* doRequestSignature({ type, payload }) {
  yield apiSaga(type, contractingApis.sendRCMsg, [{ ...payload, who: 'Supplier' }]);
}

function* updateWorkspaceContract({ type, payload }) {
  yield apiSaga(type, contractingApis.updateWorkspaceContract, [payload]);
}

function* handleSendMessage({ type, payload }) {
  if (payload.who === 'Supplier' && !payload.rateDocIds.length) {
    yield* apiSaga(
      type,
      contractingApis.submitContractingComment,
      [{
        files: payload.leanFiles || [],
        message: payload.message,
        historyFeedId: payload.historyFeedId,
        emails: payload.emails,
        subject: payload.subject,
        crId: payload.crId,
      }]
    );
  } else {
    yield apiSaga(type, contractingApis.sendRCMsg, [payload]);
  }
}

function* submitRates({ type, payload }) {
  yield apiSaga(type, contractingApis.submitRCRates, [payload]);
}

function* afterSubmitRatesAsDLSuccess({ args }) {
  yield* [
    apiSaga(
      '[contract-request]GET_RESPONDED_CONTRACT_LIST',
      contractingApis.getRespondedContractList,
      [{ requestId: args[0].crId }],
    ),
    refreshPolicyNotes({ args }),
  ];
}

function* createDummyTemplateDraftForBuyer({ type, payload }) {
  yield apiSaga(type, contractingApis.createEditedDraftForBuyer, [payload]);
}

function* afterCreateDummyTemplateDraftForBuyerSuccess({ payload }) {
  yield put({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' });
  yield put({
    type: '{dummy-account} RateDocIframe_open',
    payload: {
      url: `${payload.magicLink}&jumpBackTo=${window.location.href}`,
      collection: 'draft',
      rateDocId: payload.docId,
      isInSigning: false,
    },
  });
}

function* deleteRateSheet({ type, payload }) {
  yield apiSaga(type, contractingApis.deleteTemplateDraft, [payload]);
}

function* loadDataForIframe() {
  const { rateDocId, collection, forImport } = yield select(state => state.dummyAcct.rateDocIframe);
  if (rateDocId && collection && window.location.href.indexOf('/assets-landing') === -1 && !forImport) {
    yield apiSaga('{dummy-account} loadDataForIframe', contractingApis.loadDataForIframe, [{ rateDocId, collection }]);
  }
}
function* checkIfRateComplete({ type, payload, next, shouldBlock }) {
  const { rateDocId, collection, originFrom } = yield select(state => state.dummyAcct.rateDocIframe);
  yield all([
    apiSaga(type, contractingApis.loadDataForIframe, [{ rateDocId, collection }]),
    loadDraftDiff(),
  ]);
  const { completionPercent, rawDiffData } = yield select(state => state.dummyAcct.rateDocIframe);
  const isADraft = collection === 'draft';
  const rateInfoComplete = (() => {
    if (!isADraft) return true;
    if (originFrom === 'initial') {
      return completionPercent === 100;
    }
    return Boolean(completionPercent === 100 && rawDiffData.length);
  })();
  if (rateInfoComplete) {
    yield put({ type: next, payload });
  } else if (shouldBlock || (!rawDiffData.length && originFrom === 'edited')) {
    // if the draft does not contain any changes, we need to block because backend won't process
    if (!rawDiffData.length && originFrom === 'edited') window.alert(`You haven't made any changes yet.`);
    else window.alert('Please complete the rate sheet before continuing');
  } else {
    const confirmed = window.confirm('This rate sheet is not complete, are you sure that you want to continue?');
    if (confirmed) {
      yield put({ type: next, payload });
    }
  }
}

function* onCloseIframe() {
  // TODO: UPDATE when old view is deprecated
  let contractId;
  if (window.location.pathname.indexOf('/workspace/')) {
    contractId = (window.location.pathname.match(/^\/contracting\/workspace\/([a-f\d]{24})\//) || [])[1];
  } else {
    contractId = (window.location.pathname.match(/^\/contracting\/contract\/([a-f\d]{24})\//) || [])[1];
  }
  if (contractId) {
    yield refreshPolicyNotes({ args: [{ contractId }] });
  } else if (window.location.href.indexOf('/assets-landing') > -1) {
    const { contractId: crId } = yield select(state => state.assetsLandingReducer.request);
    yield refreshPolicyNotes({ args: [{ crId }] });
  }
}

function* discardEditedDraft({ type }) {
  const confirmed = window.confirm('Are you sure you want to discard this draft?');
  if (confirmed) {
    const { rateDocId } = yield select(state => state.dummyAcct.rateDocIframe);
    yield apiSaga(type, contractingApis.deleteEditedDraft, [rateDocId]);
  }
}

function* loadDraftDiff() {
  const { rateDocId, originFrom } = yield select(state => state.dummyAcct.rateDocIframe);
  if (originFrom === 'edited') {
    yield call(delay, 500);
    yield apiSaga('{dummy-account} loadDraftDiff', contractingApis.getDiffReport, [{ docs: `draft:${rateDocId}:${rateDocId}`, onlyGetSummary: true }]);
  }
}
export default [
  takeLatest('[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR', createTemplatesInDummyAcct),
  takeLatest('[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_SUCCESS', afterCreateTemplatesInDummyAcctSuccess),
  takeLatest('{dummy-account} ACCEPT_DUMMY_TEMPLATE', acceptDummyTemplate),
  takeLatest('{dummy-account} ACCEPT_DUMMY_TEMPLATE_SUCCESS', afterAcceptDummyTemplate),
  takeLatest('{dummy-account} REQUEST_SIGNATURE', doRequestSignature),
  takeLatest('{dummy-account} REQUEST_SIGNATURE_SUCCESS', loadDataForIframe),
  takeLatest([
    '[contract-request] UPDATE_RATE_LOADING_STATUS',
    '[contract-request] UPDATE_RATE_CONVERSION_SETTING',
    '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY',
    '[contract-request] UPDATE_CONTRACTING_WORKSPACE',
  ], updateWorkspaceContract),
  takeLatest([
    '[contract-request] UPDATE_RATE_LOADING_STATUS_SUCCESS',
    '[contract-request] UPDATE_RATE_CONVERSION_SETTING_SUCCESS',
    '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY_SUCCESS',
    '[contract-request] UPDATE_CONTRACTING_WORKSPACE_SUCCESS',
  ], refreshPolicyNotes),
  takeLatest('{rl-send-message} SEND_MESSAGE', handleSendMessage),
  takeLatest('{rl-send-message} SUBMIT_RATES_AS_DL', submitRates),
  takeLatest('{rl-send-message} SUBMIT_RATES_AS_DL_SUCCESS', afterSubmitRatesAsDLSuccess),
  takeLatest('{rl-send-message} SEND_MESSAGE_SUCCESS', refreshPolicyNotes),
  takeLatest('{rl-send-message} SEND_MESSAGE_SUCCESS', refreshActivities),
  takeLatest('{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT', createDummyTemplateDraftForBuyer),
  takeLatest('{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT_SUCCESS', afterCreateDummyTemplateDraftForBuyerSuccess),
  takeLatest('[contract-request] DELETE_RATE_SHEET', deleteRateSheet),
  takeLatest('{dummy-account} RateDocIframe_open', loadDataForIframe),
  takeLatest('{dummy-account} RateDocIframe_checkIfRateComplete', checkIfRateComplete),
  takeLatest('{dummy-account} RateDocIframe_close', onCloseIframe),
  takeLatest('{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT', discardEditedDraft),
  takeLatest('{dummy-account} loadDataForIframe_SUCCESS', loadDraftDiff),
];



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/__store-files__/sagas.js